/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationChannelUpdateListEntry } from './NotificationChannelUpdateListEntry';
import {
    NotificationChannelUpdateListEntryFromJSON,
    NotificationChannelUpdateListEntryFromJSONTyped,
    NotificationChannelUpdateListEntryToJSON,
    NotificationChannelUpdateListEntryToJSONTyped,
} from './NotificationChannelUpdateListEntry';

/**
 * 
 * @export
 * @interface NotificationPreferencesUpdateRequest
 */
export interface NotificationPreferencesUpdateRequest {
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    preferences?: Array<NotificationChannelUpdateListEntry>;
}

/**
 * Check if a given object implements the NotificationPreferencesUpdateRequest interface.
 */
export function instanceOfNotificationPreferencesUpdateRequest(value: object): value is NotificationPreferencesUpdateRequest {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    return true;
}

export function NotificationPreferencesUpdateRequestFromJSON(json: any): NotificationPreferencesUpdateRequest {
    return NotificationPreferencesUpdateRequestFromJSONTyped(json, false);
}

export function NotificationPreferencesUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferencesUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'preferences': json['preferences'] == null ? undefined : ((json['preferences'] as Array<any>).map(NotificationChannelUpdateListEntryFromJSON)),
    };
}

export function NotificationPreferencesUpdateRequestToJSON(json: any): NotificationPreferencesUpdateRequest {
    return NotificationPreferencesUpdateRequestToJSONTyped(json, false);
}

export function NotificationPreferencesUpdateRequestToJSONTyped(value?: NotificationPreferencesUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
        'preferences': value['preferences'] == null ? undefined : ((value['preferences'] as Array<any>).map(NotificationChannelUpdateListEntryToJSON)),
    };
}

